module.exports = __webpack_public_path__ + "static/angular-2345a5c4d363dd55b0d5904d0d0c9087.png";